<template>
  <v-btn
    :to="buttonTo"
    :disabled="disabled"
    class="pl-2 primary floatRight"
    @click="openModal"
  >
    <v-icon :title="iconTitle" class="mr-2"> mdi-plus</v-icon>
    {{ content }}
  </v-btn>
</template>

<script>
export default {
  props: ['name', 'iconTitle', 'routeName', 'disabled', 'to', 'text'],
  emits: ['open-modal'],

  computed: {
    buttonTo() {
      return this.to ?? { name: this.routeName }
    },

    content() {
      if (this.text) {
        return this.text
      }

      if (this.name) {
        return `Add ${this.name}`
      }

      return 'Add'
    },
  },
  methods: {
    openModal() {
      this.$emit('open-modal')
    },
  },
}
</script>

<style scoped></style>
